import {useEffect, useState} from 'react';
import {removeUnderScore} from "../utility/utility";
import {Leave_Type_Status, Week_Days} from "../constant/constant";
import dayjs from 'dayjs';
import Locale from "../core/locale/locale";

const useFetchTableData = (
    {getAll, tableColumns, deleteById}: any,
    requestParams?: object
) => {
    const [value, setValue] = useState<any>([]);
    const [loading, setLoading] = useState(true);

    function flattenObjectKeepLastKey(obj: any, result: any = {}) {
        for (let key in obj) {
            if (!obj.hasOwnProperty(key)) continue;

            const value = obj[key];

            if (value && typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)) {
                flattenObjectKeepLastKey(value, result);
            } else {
                result[key] = value;
            }
        }
        return result;
    }

    const fetchDataInsideHook = async () => {
        try {
            setLoading(true);
            const data = await getAll(requestParams);

            let newData: any = [];

            if (!Array.isArray(data)) {
                newData = [data];
            } else {
                const finalData = data.map((item) => {
                    return flattenObjectKeepLastKey(item);
                });
                newData = [...finalData];
            }

            newData = newData.map((record: any, index: number) => {
                const newRow: any = {};
                tableColumns.forEach((column: any) => {
                    // Safeguard against undefined
                    // newRow[column] = record[column] ? removeUnderScore(String(record[column])) : 'N/A';
                    if (record[column] === undefined || record[column] === null) {
                        newRow[column] = "-";
                    } else {
                        newRow[column] = removeUnderScore(String(record[column]));
                    }
                });
                newRow["key"] = `${index + 1}`;
                newRow["id"] = record.idArray || record.id || `id-${index + 1}`;

                if (record.updatedOn) {
                    newRow['updatedOn'] = dayjs(record.updatedOn).format(Locale.displayDate);
                } else {
                    newRow['updatedOn'] = '-';
                }

                if (record.startDate) {
                    newRow['startDate'] = dayjs(record.startDate).format(Locale.displayDate);
                } else {
                    newRow['startDate'] = '-';
                }

                if (record.endDate) {
                    newRow['endDate'] = dayjs(record.endDate).format(Locale.displayDate);
                } else {
                    newRow['endDate'] = '-';
                }

                if (record.updatedBy) {
                    newRow['updatedBy'] = record.updatedBy;
                } else {
                    newRow['updatedBy'] = '-';
                }

                if (record.createdOn) {
                    newRow['createdOn'] = dayjs(record.createdOn).format(Locale.displayDate);
                } else {
                    newRow['createdOn'] = '-';
                }

                if (typeof record.active === "boolean") {
                    newRow["status"] = record.active;
                    newRow["active"] = record.active ? "Active" : "Inactive";
                }
                if (record.code) {
                    newRow["code"] = record.code;
                }

                if (record.day) {
                    newRow['day'] = Week_Days[record.day as keyof typeof Week_Days];
                }

                if (record.status) {
                    newRow['status'] = Leave_Type_Status[record.status as keyof typeof Leave_Type_Status];
                }
                return newRow;
            });
            setValue([...newData]);
        } catch (e) {
            console.log("Error fetching data:", e);
        } finally {
            setLoading(false)
        }
    };

    const deleteHandle = async (record: any) => {
        try {
            await deleteById(record.id);
            setValue((prevState: any) => prevState.filter((item: any) => item.id !== record.id));
        } catch (error) {
            console.log("Error deleting record:", error);
        }
    };

    useEffect(() => {
        fetchDataInsideHook();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getAll, JSON.stringify(requestParams)]); // Add dependencies

    return {value, setValue, deleteHandle, refetch: fetchDataInsideHook,loading};
};

export default useFetchTableData;
